export default () => {
    const $ = jQuery;

    function clicker() {
        $('.status_message .close_btn').on('click', function () {
            $('.status_message').remove();
        });
    }

    $(document).ajaxComplete(function() {
        clicker();
    });
    
    clicker();
}


// WEBPACK FOOTER //
// ./modules/RemoveMessage/index.js